import { buildSchema } from "@camberi/firecms";

export const questionsSchema = buildSchema({
    name: "Questions",
    properties: {
        question: {
            title: "Question",
            dataType: "string",
            validation: { required: true },
        },
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        published: {
            title: "Published",
            dataType: "boolean",
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    },
    defaultValues: {

    }

});

export const answerSchema = buildSchema({
    name: "Answer",
    properties: {
        answer: {
            title: "Answer",
            dataType: "string",
            validation: { required: true },
        },
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        status: {
            title: "status",
            dataType: "boolean"
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp"
        },
    },
    defaultValues: {
        status:false
    }
});